import { z } from 'zod';
import { SiteSchema } from '@/api/schema/site';
import { SubjectSchema, SubjectProtocolSchema } from '@/api/schema/subject';
import { BasePatientSchema } from '@/api/schema/basePatient';

export const PatientSchema = BasePatientSchema.extend({
  subjects: z.array(SubjectSchema).optional(),
});

export const AnonymizedPatientSchema = z.object({
  id: z.string(),
  humanReadableId: z.string(),
  externalId: z.string(),
  dateOfBirth: z.string(),
  gender: z.string(),
  subjects: z.array(SubjectSchema).optional(),
  site: z.object({
    id: z.string(),
  }),
});

export const PatientListItemSchema = z.object({
  id: z.string(),
  humanReadableId: z.string(),
  externalId: z.string(),
  firstName: z.string(),
  lastName: z.string(),
  dateOfBirth: z.string(),
  gender: z.string(),
  email: z.string().optional().nullable(),
  phone: z.string().optional().nullable(),
  address: z.string().optional().nullable(),
  site: SiteSchema,
  activeSubject: z.object({
    id: z.string(),
    subjectHumanReadableId: z.string(),
    protocol: SubjectProtocolSchema,
  }).optional(),
});

export const AnonymizedPatientListItemSchema = z.object({
  id: z.string(),
  humanReadableId: z.string(),
  externalId: z.string(),
  dateOfBirth: z.string(),
  gender: z.string(),
  site: z.object({
    id: z.string(),
  }),
  activeSubject: z.object({
    id: z.string(),
    subjectHumanReadableId: z.string(),
    protocol: SubjectProtocolSchema,
  }).optional(),
});

export const ExternalIdValidationSchema = z.object({
  isAvailable: z.boolean(),
});

export type FullPatient = z.infer<typeof PatientSchema>;
export type FullPatientListItem = z.infer<typeof PatientListItemSchema>;
export type AnonymizedPatientListItem = z.infer<typeof AnonymizedPatientListItemSchema>;
export type AnonymizedPatient = z.infer<typeof AnonymizedPatientSchema> & Omit<Partial<FullPatient>,
  keyof z.infer<typeof AnonymizedPatientSchema>>;
export type Patient = FullPatient | AnonymizedPatient;
export type PatientListItem = FullPatientListItem | AnonymizedPatientListItem;

export const PatientUnionSchema = z.union([ PatientSchema, AnonymizedPatientSchema ]);
export const PatientListUnionSchema = z.union([ PatientListItemSchema, AnonymizedPatientListItemSchema ]);

export type ExternalIdValidation = z.infer<typeof ExternalIdValidationSchema>;
